import React, { useState } from "react";
import "./ContactPage.css";
import contactImage from "../images/contactImage2.jpg";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    question: "",
    message: "",
    productType: "",
    metalType: "",
    size: "",
    stone: "",
    source: "",
    file: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Submitted: ", formData);
  };

  return (
    <>

      <h2 className="contact-h2">How Can We Help?</h2>
      <div className="contact-page">
        <div className="contact-container">
          <div className="contact-image">
            <img src={contactImage} alt="Jewelry" />
          </div>
          <form className="contact-form" onSubmit={handleSubmit}>
            <label>Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <label>Email Address</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <label>Subject</label>
            <input
              type="text"
              name="subject"
              value={formData.subject}
              onChange={handleChange}
            />

            <label>Question is about</label>
            <select
              name="question"
              value={formData.question}
              onChange={handleChange}
              required
            >
              <option value="" disabled>Please select</option>
              <option value="My Order">My Order</option>
              <option value="Cancel Order">Cancel Order</option>
              <option value="Returns">Returns</option>
              <option value="Shipping">Shipping</option>
              <option value="Product Information">Product Information</option>
              <option value="Damage / Wrong">Damage / Wrong</option>
              <option value="Custom Order">Custom Order</option>
              <option value="Another Issue">Another Issue</option>
            </select>

            <label>How can we help you?</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              rows="4"
            ></textarea>

            <label>Attachments (Acceptable file types: .jpg, .pdf)</label>
            <input
              type="file"
              name="file"
              onChange={handleChange}
              accept=".jpg, .pdf"
            />

            <label>Product Type</label>
            <select
              name="productType"
              value={formData.productType}
              onChange={handleChange}
            >
              <option value="" disabled>Please select</option>
              <option value="Ring">Ring</option>
              <option value="Necklace">Necklace</option>
              <option value="Earring">Earring</option>
              <option value="Bracelet">Bracelet</option>
            </select>

            <label>Metal Type</label>
            <select
              name="metalType"
              value={formData.metalType}
              onChange={handleChange}
            >
              <option value="" disabled>Please select</option>
              <option value="14k Gold">14k Gold</option>
              <option value="14k Rose Gold">14k Rose Gold</option>
              <option value="14k White Gold">14k White Gold</option>
              <option value="Platinum">Platinum</option>
            </select>

            <label>Size / Length</label>
            <input
              type="text"
              name="size"
              value={formData.size}
              onChange={handleChange}
            />

            <label>Stone</label>
            <input
              type="text"
              name="stone"
              value={formData.stone}
              onChange={handleChange}
            />

            <label>How did you find us?</label>
            <input
              type="text"
              name="source"
              value={formData.source}
              onChange={handleChange}
            />

            <button type="submit">Submit</button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
